<template>
	<div style="margin: 0 auto;">
		<el-form ref="form" style="width: 80%;" label-position="left" :model="form" label-width="100px">
			<el-form-item label="活动名称:" style="width: 80%;">
				<el-input v-model="form.name"></el-input>
			</el-form-item>
			<el-form-item label="项目描述:" style="width: 80%;">
				<el-input v-model="form.desc"></el-input>
			</el-form-item>
			<el-form-item label="地点:" style="width: 80%;">
				<el-row style="width: 100%;display: flex;flex-direction: row;justify-content: flex-start;">
					<el-select :span="12" style="margin-right: 1.25rem;width: 80%;" v-model="form.provinceid" placeholder="请选择省份" @change="selectProvince">
						<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<el-select :span="12" style="width: 80%;" v-model="form.cityid" placeholder="请选择市或区">
						<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-row>

			</el-form-item>
			<el-form-item label="网站地址:" style="width: 80%;">
				<el-input v-model="form.address"></el-input>
			</el-form-item>
			<el-form-item label="项目负责人:" style="width: 80%;">
				<el-select v-model="form.leaderid" style="width: 100%;" placeholder="请选择项目负责人">
					<el-option v-for="item in optionList" :key="item.id" :label="item.loginName" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<!-- <el-form-item label="落地页:" style="width: 40%;text-align: left;">
				<el-button type="primary" size="small" style="width: 5rem;" @click="addPageAction">新建</el-button>
			</el-form-item> -->
		</el-form>

		<!-- <el-table :data="tableData" height="220" border style="width: 80%">
			<el-table-column prop="name" label="名称" width="180">
			</el-table-column>
			<el-table-column prop="source" label="来源" width="180">
			</el-table-column>
			<el-table-column prop="chanel" label="渠道">
			</el-table-column>
			<el-table-column prop="remark" label="备注">
			</el-table-column>
			<el-table-column prop="address" label="网址">
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="100">
				<template slot-scope="scope">
					<el-button @click="handleClick(scope.row)" type="text" :disabled="true" size="small">查看</el-button>
					<el-button type="text" :disabled="true" size="small">编辑</el-button>
				</template>
			</el-table-column>
		</el-table> -->

		<div style="margin-top: 2.5rem;width: 65%;">
			<el-button type="primary" @click="onSubmit" style="width: 6.25rem;height: 2.8125rem;margin-right: 1.25rem;">保存</el-button>
			<el-button style="width: 6.25rem;height: 2.8125rem;" @click="back">取消</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'addproject',
		props: {
			projInfo: {}
		},
		data() {
			return {
				form: {
					name: '',
					desc: '',
					address: '',
					leaderid: '',
					provinceid: '',
					cityid: '',
					id: ''
				},
				isEdit:false,
				projDetail:this.projInfo,
				tableData: [],
				optionList: [],
				provinceList: [],
				cityList: [],
			}
		},

		mounted() {
			console.log('addproject mounted projdetail = ', this.projDetail)
			this.getProvinceRequest()
			this.getLeaderRequest()
			
			if (this.projDetail !== null) {
				this.isEdit = true
				this.form.name = this.projDetail.name
				this.form.desc = this.projDetail.describe
				this.form.address = this.projDetail.webUrl
				this.form.leaderid = this.projDetail.userId
				this.form.provinceid = this.projDetail.provinceId
				this.form.id = this.projDetail.id
				
				this.selectProvince(this.form.provinceid)
				
				// this.form.cityid = this.projDetail.cityId
			}
		},

		methods: {
			addPageAction() {
				console.log('addproject addPageAction')
				this.$emit('addPage')
			},

			onSubmit() {
				console.log('addproject onSubmit')
				this.$emit('saveProject', this.isEdit, this.form)
			},

			back() {
				console.log('addproject back')
				this.$emit('addBack')
			},

			async getLeaderRequest() {
				var api = "/projectchat/project/leader/list";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						name: ''
					},
				});
				console.log("addproject getLeaderRequest response = ", response);
				if (response.resultCode === '10000') {
					this.optionList = response.data
				} else {
					this.$message.error(response.desc)
				}
			},

			async getProvinceRequest() {
				var api = "/projectchat/region/pass/selectProvince";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						level: 1
					},
				});
				console.log("addproject getProvinceRequest response = ", response);
				if (response.resultCode === '10000') {
					this.provinceList = response.data
				} else {
					this.$message.error(response.desc)
				}
			},

			async getCityRequest(pid) {
				var api = "/projectchat/region/pass/selectProvince";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {
						parendId: pid
					},
				});
				console.log("addproject getCityRequest response = ", response);
				if (response.resultCode === '10000') {
					this.cityList = response.data
					if (!this.projDetail) {
						console.log('addproject 111')
						let firstCity = this.cityList[0]
						this.form.cityid = firstCity.id
					} else {
						console.log('addproject 222')
						let cid = this.projDetail.cityId
						this.cityList.forEach((item) => {
							// console.log('item = ', item, cid)
							if (item.id === cid) {
								this.form.cityid = item.id
							}
						})
						console.log('form cityid = ', this.form.cityid)
					}
					
				} else {
					this.$message.error(response.desc)
				}
			},

			selectProvince(val) {
				console.log('addproject selectProvince val = ', val)
				this.getCityRequest(val)

			},
		}
	}
</script>

<style scoped="scoped">

</style>
